export default __webpack_public_path__ + "static/media/banner.e6333c09.jpg";